var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1890eb7578c907e42e2466ec8f164147.js').default;export default
        Object.assign({}, scope_0 )
    